import React from 'react'
import styles from './VictoryPointCountBanner.module.scss'
import {TranslationObject} from '@colonist/i18n'
import {T, Tooltip} from '@colonist/ui'
import clsx from 'clsx'
import RibbonSmall from '@static/images/ribbon_small.svg'
import RibbonShort from '@static/images/ribbon_short.svg'

export interface VictoryPointCountBannerProps {
    className?: string
    victoryPointsText: TranslationObject
    victoryPointsToWin: number
    isLargeRibbon?: boolean
}

export const VictoryPointCountBanner = ({
    className,
    victoryPointsText,
    victoryPointsToWin,
    isLargeRibbon,
}: VictoryPointCountBannerProps) => (
    <Tooltip
        className={clsx(styles.victoryPointsContainer, className, {
            [styles.largeRibbon]: isLargeRibbon,
        })}
        content={<T id={{
            key: 'strings:game.playerInformation.victoryPoint.body',
            options: {count: victoryPointsToWin},
        }}/>}
        title={<T id='strings:game.playerInformation.victoryPoint.title'/>}>
        <img
            className={clsx(styles.ribbon, {
                [styles.largeRibbon]: isLargeRibbon,
            })}
            src={isLargeRibbon ? RibbonShort : RibbonSmall}
        />
        <span className={clsx(styles.victoryPoints)}><T id={victoryPointsText}/></span>
    </Tooltip>
)
